import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { Boundary } from './components/boundary';
import './index.css';

// Not redundant with the routes' own screens: the router's boundary asks
// whether the thrown value is truthy, so `throw undefined` slips past every one
// of them and leaves an empty document. Nothing resets this one — reaching it
// means the whole app failed.
createRoot(document.getElementById('root')!, {
  // React's default for a CAUGHT error is console.error, which the browser SDK
  // collects as an error of its own -- so every contained failure arrived twice,
  // once tagged with the region that caught it and once not. The boundaries
  // report deliberately; this drops the untagged copy and keeps the local one
  // for development, where the console is the point.
  onCaughtError: (error, info) => {
    if (import.meta.env.DEV) console.error(error, info.componentStack);
  },
}).render(
  <StrictMode>
    <Boundary where="region:app-root" resetKey="app" size="page">
      <RouterProvider router={router} />
    </Boundary>
  </StrictMode>,
);
